import { inject, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { LanguageService } from '../../core/services/language.service';
import { MAX_DATE } from '../constants/max-date.const';
import { DueAtDateTimeInfo } from '../contract/due-date-info-date-time.contract';
import { DueDateInfo } from '../contract/due-date-info.contract';
import { TimezoneService } from '../services/timezone.service';
import { FormatDateTimePipe } from './format-date-time.pipe';

@Pipe({
  name: 'dueDate',
  standalone: true,
})
export class DueDatePipe implements PipeTransform {
  private readonly timezoneService = inject(TimezoneService);

  private circaAbbr = this.languageService.getInstant('general.circa.abbr');

  constructor(
    private languageService: LanguageService,
    private formatDateTimePipe: FormatDateTimePipe,
  ) {}

  public transform(dueDateInfo: DueDateInfo | DueAtDateTimeInfo): string {
    if (dueDateInfo && dueDateInfo.dueDate && this.notMaxDate(dueDateInfo.dueDate)) {
      return [
        dueDateInfo.dueDateEstimated ? this.circaAbbr : null,
        this.formatDateTimePipe.transform(dueDateInfo.dueDate),
      ]
        .filter(Boolean)
        .join(' ');
    }

    return '';
  }

  private notMaxDate(date: string): boolean {
    // undo TimezoneInterceptor - EC20-1814
    const shiftMinutes = this.timezoneService.getUserTimezoneShiftMinutes();
    return !moment.utc(date).subtract(shiftMinutes, 'minutes').isSame(moment.utc(MAX_DATE), 'day');
  }
}
